export const ACCESS_DENIED_MESSAGE =
  "Bạn không có quyền truy cập vào trang này";

type AccessDeniedListener = (message: string) => void;

const listeners = new Set<AccessDeniedListener>();

/**
 * Kênh báo "bị chặn quyền" cực nhẹ: chỉ giữ danh sách người nghe.
 *
 * Nhờ vậy lớp chặn đường dẫn (guard) có thể báo cho khung ứng dụng hiện thông
 * báo, mà không phải nhét state chung vào context hay kéo cả cây vẽ lại.
 */
export function notifyAccessDenied(message: string = ACCESS_DENIED_MESSAGE) {
  listeners.forEach((listener) => listener(message));
}

export function subscribeAccessDenied(listener: AccessDeniedListener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}